import { useState } from 'react'
import { api, ErroreApi } from '../servizi/api.ts'
import { useSessione } from '../servizi/sessione.tsx'
import { Avviso, Pie } from '../componenti/Pezzi.tsx'
import { Bottone, Campo } from '../componenti/base.tsx'

/**
 * Porta il foco sul campo al momento dell'inserimento nel documento.
 * La funzione e' dichiarata fuori dal componente: l'identita' resta stabile fra un disegno
 * e l'altro e il riferimento non viene riagganciato a ogni battuta.
 */
function focoIniziale(elemento: HTMLInputElement | null) {
  elemento?.focus()
}

/**
 * Cambio obbligatorio della password.
 *
 * Chi entra con una password provvisoria — consegnata da chi ha creato l'utenza oppure
 * rimessa dall'amministratore — non raggiunge il resto dell'applicazione finche' non ne
 * imposta una propria. Una password nota anche ad altri rende gli accessi non attribuibili
 * a un solo utente.
 *
 * Il cambio chiude tutte le altre sessioni aperte con lo stesso account.
 */
export function CambioPassword() {
  const { aggiorna, esci } = useSessione()
  const [attuale, setAttuale] = useState('')
  const [nuova, setNuova] = useState('')
  const [ripetuta, setRipetuta] = useState('')
  const [errore, setErrore] = useState<string | null>(null)
  const [inCorso, setInCorso] = useState(false)

  const differiscono = ripetuta.length > 0 && nuova !== ripetuta
  const puoInviare = attuale.length > 0 && nuova.length >= 12 && nuova === ripetuta && !inCorso

  return (
    <div className="accesso">
      <div className="riquadro">
        <div className="scheda">
          <div className="stemma">
            <img src="/immagini/cidis-logo.png" alt="C.I.D.I.S. Impresa Sociale ETS" />
          </div>
          <h1>Nuova password</h1>
          <p className="occhiello">Accesso con password provvisoria</p>

          {errore && <Avviso tipo="errore">{errore}</Avviso>}

          <Avviso tipo="attenzione">
            La password provvisoria è stata scelta da un’altra persona. Finché resta in vigore,
            le operazioni compiute con questo account non sono attribuibili a un solo utente:
            l’applicazione non si apre prima del cambio.
          </Avviso>

          <form onSubmit={(e) => {
            e.preventDefault()
            setErrore(null)
            setInCorso(true)
            void (async () => {
              try {
                await api.post('/auth/password/cambia', { attuale, nuova })
                await aggiorna()
              } catch (err) {
                setErrore(err instanceof ErroreApi ? err.message
                  : 'Non è andata a buon fine: controlla la connessione e riprova.')
              } finally {
                setInCorso(false)
              }
            })()
          }}>
            <Campo
              etichetta="Password provvisoria"
              tipo="password"
              valore={attuale}
              cambia={setAttuale}
              autoComplete="current-password"
              obbligatorio
              riferimento={focoIniziale}
            />
            <Campo
              etichetta="Nuova password"
              tipo="password"
              valore={nuova}
              cambia={setNuova}
              autoComplete="new-password"
              obbligatorio
              minLength={12}
              aiuto="Minimo dodici caratteri. Non sono richiesti maiuscole o simboli. Le password più diffuse non sono accettate."
            />
            <Campo
              etichetta="Conferma password"
              tipo="password"
              valore={ripetuta}
              cambia={setRipetuta}
              autoComplete="new-password"
              obbligatorio
              errore={differiscono ? 'Le due password non coincidono.' : null}
            />

            <Bottone tipo="submit" variante="primario" larghezzaPiena
                     inCorso={inCorso} disabled={!puoInviare}>
              Cambia password
            </Bottone>
          </form>

          <p className="accesso-nota">
            Il cambio chiude tutte le altre sessioni aperte con questo account.
          </p>
          <div className="accesso-uscita">
            <Bottone variante="discreto" larghezzaPiena onClick={() => { void esci() }}>
              Esci
            </Bottone>
          </div>
        </div>
        <Pie />
      </div>
    </div>
  )
}
